import { Checkbox } from '@mui/material'
import { useEffect, useState } from 'react'
import useStyles from './useStyles'

function TableHeader ({ allChecked, setAllChecked, setElementsChecked }) {
  const classes = useStyles()
  const [checked, setChecked] = useState(false)

  // handle change check-box value
  const handleChange = (event) => {
    setChecked(event.target.checked)
    setAllChecked(event.target.checked)
    if (!event.target.checked) {
      setElementsChecked([])
    }
  }

  useEffect(() => {
    allChecked ? setChecked(true) : setChecked(false)
  }, [allChecked])

  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox checked={checked} onChange={handleChange} />
        </th>
        <th className={classes.headName}>Nombre</th>
        <th className={classes.headAbsolutePath}>Ruta</th>
        <th className={classes.headPurgeActionUser}>Eliminado por</th>
        <th className={classes.headPurgeDate}>Fecha de eliminación</th>

        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
